import { useState, useEffect, useCallback, useRef, createContext, useContext } from 'react';
import { Button, Spin, Tag, Empty, notification, Input, Modal, Slider, Badge, Tooltip } from 'antd';
import {
  UserOutlined, BankOutlined, ShopOutlined, LogoutOutlined,
  CheckCircleOutlined, ClockCircleOutlined, EnvironmentOutlined,
  SearchOutlined, EditOutlined, AppstoreOutlined, StarOutlined,
  PrinterOutlined, DownloadOutlined, EyeOutlined, HomeOutlined,
  PhoneOutlined, MailOutlined, CalendarOutlined, GiftOutlined,
  TeamOutlined, TrophyOutlined, IdcardOutlined, ShareAltOutlined,
  PlusOutlined, LockOutlined, CameraOutlined, LoadingOutlined, ScissorOutlined, PictureOutlined,
  FilePdfOutlined, FileTextOutlined, BuildOutlined, FilterOutlined,
  BellFilled, HeartOutlined, UserAddOutlined, CheckOutlined, CloseOutlined,
  LinkOutlined, CrownOutlined, WhatsAppOutlined,
  NotificationOutlined, BankFilled, UsergroupAddOutlined,
  CustomerServiceOutlined, SoundOutlined, LikeOutlined, MessageOutlined, SendOutlined,
  CompassOutlined, ToolOutlined, BulbOutlined, GlobalOutlined,
  FireOutlined, RiseOutlined,
  ReadOutlined, QuestionCircleOutlined, InfoCircleOutlined,
  BookOutlined, ThunderboltOutlined, AimOutlined,
  PushpinOutlined, PushpinFilled, StarFilled, MoreOutlined,
  WifiOutlined, SettingOutlined, LeftOutlined, RightOutlined, DeleteOutlined,
} from '@ant-design/icons';
import Cropper from 'react-easy-crop';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { baseUrl, rozerpay_key_id, socketUrl } from '../../config';
import { io as socketIo } from 'socket.io-client';

import { M, ML, G, BG } from './shared/constants';
import { authHeader, ssGet, ssSet, ssInvalidate, LangCtx, useLang, isBirthdayToday, countryFlag } from './shared/utils';
import { useMobile } from './shared/hooks';

import { HomeDashboardTab } from './tabs/HomeDashboard';
import { ProfileTab, TempAddressSection } from './tabs/Profile';
import { PaymentsTab } from './tabs/Payments';
import { DirectoryTab, MyBusinessTab } from './tabs/Business';
import { CommunityBoardTab, CombinedMembersTab, MemberDirectoryTab } from './tabs/Members';
import { CombinedContributionTab } from './tabs/Contributions';
import { JobsTab } from './tabs/Jobs';
import { VivahParichayTab } from './tabs/Vivah';
import { StudentSupportTab } from './tabs/StudentSupport';
import { CombinedServicesTab } from './tabs/Services';
import { MemberChatTab } from './tabs/Chat';
import { VillageDirectoryTab } from './tabs/Village';
import { MyFamilyRecordTab } from './tabs/Family';
import { ActivityTab, DevelopmentTab } from './tabs/Activity';
import { InquiryTab } from './tabs/Inquiry';
import { MyContactsTab } from './tabs/Contacts';
import { FestivalCelebration, BirthdayCelebration, ReferrerPromptModal, BecomeMemberModal } from './tabs/Celebrations';
import { MembershipCard } from './components/MembershipCard';

import { NotificationPanel } from './tabs/Community';
import { AnnouncementsTab, SamajTab } from './tabs/Contacts';
import { ReportsSubTab } from './tabs/Activity';
import { SamajParichayTab } from './tabs/Vivah';
import { ReferralTab } from './tabs/Contributions';
import { registerPushSubscription } from './tabs/Vivah';
import { GotraDirectoryTab, SammelanTab, CityCommunityTab } from './tabs/Village';
import { ContributionsTab } from './tabs/Contributions';
import { GalleryTab } from './tabs/Gallery';
import { lastSeen } from './components/PostCard';

export default function UserPortal() {
  const [lang, setLangState] = useState(() => localStorage.getItem('portal_lang') || 'hi');
  const setLang = (l) => { setLangState(l); localStorage.setItem('portal_lang', l); };
  const t = (hi, en) => lang === 'en' ? en : hi;

  const [profile,        setProfile]        = useState(null);
  const [loading,        setLoading]        = useState(true);
  const [activeTab,      setActiveTab]      = useState('home');
  const [floatInquiryOpen, setFloatInquiryOpen] = useState(false);
  const [floatForm,      setFloatForm]      = useState({ subject: '', message: '', inquiry_type: 'General' });
  const [floatSending,   setFloatSending]   = useState(false);
  const [floatChatPreview,  setFloatChatPreview]  = useState(null); // { sender_name, sender_photo, message, from_user_id }
  const floatPreviewTimer = useRef(null);
  const [incomingRequest,  setIncomingRequest]  = useState(null); // { sender_name, sender_photo, from_user_id, message }
  const [notifOpen,        setNotifOpen]        = useState(false);
  const [unreadCount,      setUnreadCount]      = useState(0);
  const [tabBadges,        setTabBadges]        = useState({ contacts: 0, board: 0, development: 0, chat: 0 });
  const [canScrollLeft,    setCanScrollLeft]    = useState(false);
  const [canScrollRight,   setCanScrollRight]   = useState(false);
  const tabBarRef = useRef(null);
  const [birthdays,        setBirthdays]        = useState([]);
  const [birthdayDismissed,setBirthdayDismissed]= useState(false);
  const [wishPerson,       setWishPerson]       = useState(null);  // { id, name, photo, father_name, village }
  const [sendingWish,      setSendingWish]      = useState({});
  const [referrerPrompt,   setReferrerPrompt]   = useState(false);
  const [bdayCelebration,  setBdayCelebration]  = useState(false);
  const [festival,         setFestival]         = useState(null);
  const [showJoinModal,    setShowJoinModal]    = useState(false);
  const [homeOnlineUsers,  setHomeOnlineUsers]  = useState([]);
  const [chatOpenTarget,   setChatOpenTarget]   = useState(null);
  const [chatOpenTargetData, setChatOpenTargetData] = useState(null); // { id, name, photo, village }
  const [paymentFlash,     setPaymentFlash]     = useState(null); // { id, name, photo, village, amount }
  const [quickPayTrigger,  setQuickPayTrigger]  = useState(0);
  const lastPaymentId = useRef(null);
  const [emailPrompt,      setEmailPrompt]      = useState(false); // show email collection banner
  const [emailInput,       setEmailInput]       = useState('');
  const [emailSaving,      setEmailSaving]      = useState(false);
  const [isDeactivated,    setIsDeactivated]    = useState(false);
  const history = useHistory();
  const mobile  = useMobile();

  const token      = localStorage.getItem('memberToken');
  const memberInfo = (() => { try { return JSON.parse(localStorage.getItem('memberInfo') || '{}'); } catch { return {}; } })();

  const handleDeactivatedSession = useCallback(() => {
    localStorage.removeItem('memberToken');
    localStorage.removeItem('memberInfo');
    setIsDeactivated(true);
  }, []);

  const fetchProfile = useCallback(async (silent = false) => {
    if (!silent) setLoading(true);
    try {
      const res = await axios.get(`${baseUrl}/member/me`, { headers: authHeader() });
      if (res.data.status) setProfile(res.data.result);
    } catch (err) {
      if (err.response?.status === 401) {
        localStorage.removeItem('memberToken');
        localStorage.removeItem('memberInfo');
        history.push('/user-portal-login');
      } else if (err.response?.status === 403 && err.response?.data?.deactivated) {
        handleDeactivatedSession();
      }
    } finally { if (!silent) setLoading(false); }
  }, [history, handleDeactivatedSession]);

  useEffect(() => {
    if (!token) { history.push('/user-portal-login'); return; }
    fetchProfile();
    // Register push subscription silently after login (no-op if permission denied or unsupported)
    const pushKey = `pushAsked_${new Date().toISOString().slice(0,10)}`;
    if (!sessionStorage.getItem(pushKey)) {
      sessionStorage.setItem(pushKey, '1');
      setTimeout(() => registerPushSubscription(), 4000); // delay so it doesn't compete with page load
    }
    const params = new URLSearchParams(window.location.search);
    if (params.get('payment_return') === '1') {
      ssInvalidate('home_dash_v2');
      setActiveTab('payments');
      window.history.replaceState({}, '', '/user-portal');
    }
  }, [token, fetchProfile, history]); // eslint-disable-line

  // Email prompt — show once per session if email not set
  useEffect(() => {
    if (!profile) return;
    if (profile.email) return; // already has email from server
    if (localStorage.getItem('emailSaved')) return; // user saved email this browser
    const dismissed = sessionStorage.getItem('emailPromptDismissed');
    if (dismissed) return;
    const t = setTimeout(() => setEmailPrompt(true), 3000); // delay so page settles first
    return () => clearTimeout(t);
  }, [profile]);

  const saveEmail = async () => {
    const trimmed = emailInput.trim();
    if (!trimmed || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
      notification.warning({ message: 'Valid email दर्ज करें', placement: 'topRight' }); return;
    }
    setEmailSaving(true);
    try {
      const res = await axios.patch(`${baseUrl}/member/profile`, { email_address: trimmed }, { headers: authHeader() });
      if (res.data.status) {
        notification.success({ message: '✅ Email सुरक्षित हो गई!', description: 'अब आपको chat requests की email notification मिलेगी।', placement: 'topRight', duration: 4 });
        setEmailPrompt(false);
        // Mark as saved so it never re-appears (survives reload via localStorage)
        localStorage.setItem('emailSaved', '1');
        sessionStorage.setItem('emailPromptDismissed', '1');
        setProfile(prev => ({ ...prev, email: trimmed }));
        fetchProfile(); // re-fetch to confirm saved email from server
      }
    } catch { notification.error({ message: 'Email save नहीं हुई', placement: 'topRight' }); }
    finally { setEmailSaving(false); }
  };

  // Fetch today's birthdays once after profile loads
  useEffect(() => {
    if (!token || !profile) return;
    axios.get(`${baseUrl}/member/birthday-today`, { headers: authHeader() })
      .then(r => { if (r.data.status) setBirthdays(r.data.result || []); })
      .catch(() => {});
  }, [token, profile]); // eslint-disable-line

  // Show referrer prompt only for new members (joined ≤90 days ago) with no referrer
  useEffect(() => {
    if (!profile) return;
    if (profile.has_referrer) return;

    // Established members — joined more than 90 days ago — skip
    if (profile.joining_date) {
      const daysSinceJoin = (Date.now() - new Date(profile.joining_date).getTime()) / (1000 * 60 * 60 * 24);
      if (daysSinceJoin > 90) return;
    }

    // Permanently dismissed on this device
    const dismissKey = `referrerPromptDone_${profile.id}`;
    if (localStorage.getItem(dismissKey)) return;

    const t = setTimeout(() => setReferrerPrompt(true), 1200);
    return () => clearTimeout(t);
  }, [profile]); // eslint-disable-line

  // Festival animation — check on load; bypass browser cache so new festivals show immediately
  useEffect(() => {
    if (!token) return;
    const today = new Date().toISOString().slice(0, 10);
    axios.get(`${baseUrl}/member/today-festival?t=${Date.now()}`, {
      headers: authHeader(),
    })
      .then(r => {
        if (r.data.status && r.data.festival) {
          const f = r.data.festival;
          // Use festival id in key — so updated/new festivals show even on same day
          const seenKey = `festivalSeen_${today}_${f.id}`;
          if (localStorage.getItem(seenKey)) return;
          setTimeout(() => {
            setFestival(f);
            localStorage.setItem(seenKey, '1');
          }, 1500);
        }
      }).catch(() => {});
  }, [token]); // eslint-disable-line

  // Birthday celebration — show once per day
  useEffect(() => {
    if (!profile?.dob) return;
    if (!isBirthdayToday(profile.dob)) return;
    const seenKey = `bdayCelebSeen_${profile.id}_${new Date().toISOString().slice(0, 10)}`;
    if (localStorage.getItem(seenKey)) return;
    const t = setTimeout(() => {
      setBdayCelebration(true);
      localStorage.setItem(seenKey, '1');
    }, 800);
    return () => clearTimeout(t);
  }, [profile]); // eslint-disable-line

  const sendBirthdayWish = async (memberId) => {
    setSendingWish(s => ({ ...s, [memberId]: true }));
    try {
      await axios.post(`${baseUrl}/member/notify/birthday`, { to_user_id: memberId }, { headers: authHeader() });
      notification.success({ message: '🌸 जन्मदिन की शुभकामनाएं भेजी गईं!' });
      setBirthdays(prev => prev.map(b => b.id === memberId ? { ...b, already_wished: true } : b));
      setWishPerson(null);
    } catch (err) {
      notification.warning({ message: err.response?.data?.message || 'Could not send wish' });
    } finally { setSendingWish(s => ({ ...s, [memberId]: false })); }
  };

  // Poll unread notification count every 20 seconds
  useEffect(() => {
    if (!token) return;
    const poll = async () => {
      try {
        const res = await axios.get(`${baseUrl}/member/notifications/count`, { headers: authHeader() });
        if (res.data.status) setUnreadCount(res.data.count || 0);
      } catch {}
    };
    poll();
    const interval = setInterval(poll, 20000);
    return () => clearInterval(interval);
  }, [token]); // eslint-disable-line

  // Poll tab badges every 25s; use localStorage "last seen" timestamps
  useEffect(() => {
    if (!token) return;
    const poll = async () => {
      try {
        const sinceBoard = localStorage.getItem('tabSeen_board')       || '0';
        const sinceDev   = localStorage.getItem('tabSeen_development') || '0';
        const [badgeRes, chatRes] = await Promise.all([
          axios.get(`${baseUrl}/member/tab-badges?since_board=${sinceBoard}&since_dev=${sinceDev}`, { headers: authHeader() }),
          axios.get(`${baseUrl}/member/chat/unread-count`, { headers: authHeader() }),
        ]);
        setTabBadges(prev => ({
          contacts:    badgeRes.data.status ? (badgeRes.data.contacts    || 0) : prev.contacts,
          board:       badgeRes.data.status ? (badgeRes.data.board       || 0) : prev.board,
          development: badgeRes.data.status ? (badgeRes.data.development || 0) : prev.development,
          chat: chatRes.data.status ? (chatRes.data.total || 0) : prev.chat,
        }));
      } catch {}
    };
    poll();
    const iv = setInterval(poll, 25000);
    return () => clearInterval(iv);
  }, [token]); // eslint-disable-line

  // Poll online members for the Home tab strip every 30s
  useEffect(() => {
    if (!token) return;
    const poll = async () => {
      try {
        const r = await axios.get(`${baseUrl}/member/chat/online-users`, { headers: authHeader() });
        if (r.data.status) setHomeOnlineUsers(r.data.result || []);
      } catch {}
    };
    poll();
    const iv = setInterval(poll, 30000);
    return () => clearInterval(iv);
  }, [token]); // eslint-disable-line

  // Poll latest payment every 10s — flash when a new one appears
  useEffect(() => {
    if (!token) return;
    const poll = async () => {
      try {
        const r = await axios.get(`${baseUrl}/member/latest-payment`, { headers: authHeader() });
        if (r.data.status && r.data.result) {
          const p = r.data.result;
          if (lastPaymentId.current === null) { lastPaymentId.current = p.id; return; } // seed on first load
          if (p.id !== lastPaymentId.current) {
            lastPaymentId.current = p.id;
            setPaymentFlash(p);
            setTimeout(() => setPaymentFlash(null), 6000);
          }
        }
      } catch {}
    };
    poll();
    const iv = setInterval(poll, 10000);
    return () => clearInterval(iv);
  }, [token]); // eslint-disable-line

  // deep-link sub-tab: e.g. switchTab('development', 'shiksha')
  const [devInitialSubTab,      setDevInitialSubTab]      = useState(null);
  const [servicesInitialSub,    setServicesInitialSub]    = useState(null);
  const [boardInitMyView,  setBoardInitMyView]  = useState(false);

  // Mark tab as seen and clear its badge when user opens it
  const switchTab = (key, subKey) => {
    if (['board', 'development', 'contacts'].includes(key)) {
      localStorage.setItem(`tabSeen_${key}`, String(Date.now()));
      setTabBadges(prev => ({ ...prev, [key]: 0 }));
    }
    if (key === 'chat') {
      setTabBadges(prev => ({ ...prev, chat: 0 }));
    }
    if (key === 'development' && subKey) setDevInitialSubTab(subKey);
    if (key === 'services' && subKey) setServicesInitialSub(subKey);
    if (key === 'board' && subKey === 'mine') setBoardInitMyView(true);
    setActiveTab(key);
  };

  // Tab bar scroll arrows
  const updateScrollArrows = useCallback(() => {
    const el = tabBarRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 4);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 4);
  }, []);

  useEffect(() => {
    const el = tabBarRef.current;
    if (!el) return;
    updateScrollArrows();
    el.addEventListener('scroll', updateScrollArrows, { passive: true });
    const ro = new ResizeObserver(updateScrollArrows);
    ro.observe(el);
    return () => { el.removeEventListener('scroll', updateScrollArrows); ro.disconnect(); };
  }, [updateScrollArrows]);

  // Auto-scroll active tab into view
  useEffect(() => {
    const el = tabBarRef.current;
    if (!el) return;
    const active = el.querySelector('[data-active="true"]');
    if (active) active.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
  }, [activeTab]);

  const scrollTabs = (dir) => {
    const el = tabBarRef.current;
    if (el) el.scrollBy({ left: dir * 140, behavior: 'smooth' });
  };

  const logout = () => { localStorage.removeItem('memberToken'); localStorage.removeItem('memberInfo'); history.push('/user-portal-login'); };

  // Quick referral share from header — same message as ReferralTab
  const quickShare = () => {
    const code        = profile?.membership_no || (profile?.id ? `ABRSVS#${profile.id}` : null);
    const senderName  = profile?.name_hn || profile?.name || 'एक सदस्य';
    const portalUrl   = 'https://portal.brahmdhamtirth.org/user-portal-login';
    const codeBlock   = code ? `\n\n🔑 *आपका रेफरल कोड:*\n*${code}*\n_( पंजीकरण करते समय यह कोड जरूर डालें )_` : '';
    const msg =
`समाज शिक्षा निधि समर्पण योजना
🙏 *जय गुरूमहाराज री सा* 🙏

नमस्ते!

*${senderName}* जी ने आपको *अखिल भारतीय राजपुरोहित समाज विकास संस्थान (ABRSVS)* से जोड़ने के लिए आमंत्रित किया है।

━━━━━━━━━━━━━━━━
🏛️ *समाज शिक्षा निधि समर्पण योजना*
━━━━━━━━━━━━━━━━
समाज के बच्चों की शिक्षा व विकास के लिए हम सब मिलकर योगदान करें।${codeBlock}

✅ *सदस्यता के लाभ:*
• 📚 समाज की जानकारी एक जगह
• 💳 भुगतान व रसीद की सुविधा
• 🏘️ गाँव निर्देशिका व जनगणना
• 🤝 योगदान की पारदर्शिता

📲 *अभी जुड़ें:*
${portalUrl}

_"नया सदस्य बनें" पर क्लिक करें → फॉर्म भरें → रेफरल कोड डालें_`;
    if (navigator.share) {
      navigator.share({ title: 'ABRSVS — समाज शिक्षा निधि', text: msg }).catch(() => {
        window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, '_blank');
      });
    } else {
      window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, '_blank');
    }
  };

  const isSNUser        = profile?.type === 'sn_user';
  const isActive        = isSNUser ? profile?.is_active === true : true;
  const hasBusiness     = isSNUser ? !!profile?.business : true;
  const bizVerified     = profile?.business?.verification_status === 'verified';
  const myEntryId       = isSNUser ? profile?.business?.id : profile?.id;
  const memberName      = profile?.name;
  const memberNo        = profile?.membership_no;
  const missionEnrolled = isSNUser && profile?.mission_enrolled;

  // ── TAB VISIBILITY RULES ─────────────────────────────────────────────────────
  // Business-directory-only member → only biz-directory tab
  // sn_user (Shiksha Nidhi member) → all tabs, but inactive ones are "locked"
  // Tabs that are always accessible regardless of active status:
  const ALWAYS_ACCESSIBLE = new Set(['home', 'payments', 'profile']);

  const PROFILE_TABS = !isSNUser
    ? [] // directory-only: no profile tabs, only biz-directory shown below
    : [
        { key: 'home',        label: t('होम',          'Home'),           icon: <HomeOutlined /> },
        { key: 'chat',        label: t('मैसेंजर',      'Chat'),           icon: <MessageOutlined /> },
        { key: 'payments',    label: t('समर्पण',       'Payments'),       icon: <BankOutlined /> },
        { key: 'board',       label: t('समाज मंच',     'Community'),      icon: <CrownOutlined /> },
        { key: 'directory',   label: t('सदस्य',        'Members'),        icon: <SearchOutlined /> },
        { key: 'contacts',    label: t('संपर्क',       'Contacts'),       icon: <LinkOutlined /> },
        { key: 'samachar',    label: t('समाचार',       'News'),           icon: <SoundOutlined /> },
        { key: 'profile',     label: t('प्रोफ़ाइल',    'Profile'),        icon: <UserOutlined /> },
        { key: 'community',   label: t('योगदान',       'Contribution'),   icon: <TrophyOutlined /> },
        ...(hasBusiness ? [{ key: 'business', label: t('मेरा व्यवसाय', 'My Business'), icon: <ShopOutlined /> }] : []),
        { key: 'villages',    label: t('गाँव',         'Villages'),       icon: <EnvironmentOutlined /> },
        { key: 'jobs',        label: t('रोजगार',       'Jobs'),           icon: <RiseOutlined /> },
        { key: 'services',    label: t('सेवाएं',       'Services'),       icon: <AppstoreOutlined /> },
        { key: 'seva',        label: t('पूछताछ',       'Inquiry'),        icon: <CustomerServiceOutlined /> },
        { key: 'student-help', label: t('शिक्षा सहायता','Student Help'),  icon: <BookOutlined /> },
        { key: 'development', label: t('विकास',        'Development'),    icon: <BuildOutlined /> },
        { key: 'janganana',   label: t('जनगणना',       'Census'),         icon: <TeamOutlined /> },
        { key: 'referral',    label: t('रेफर करें',    'Refer'),          icon: <UsergroupAddOutlined /> },
        { key: 'gallery',     label: t('गैलरी',        'Gallery'),        icon: <PictureOutlined /> },
      ];

  // Biz Directory: show for all (including inactive) so they can explore
  const showBizDir  = true;
  // Inactive users can browse all tabs freely — payment banners inside tabs remind them to pay
  const isTabLocked = (_key) => false;

  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: BG }}>
      <Spin size="large" />
    </div>
  );

  if (isDeactivated) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff2f0', padding: 24 }}>
      <div style={{ maxWidth: 420, textAlign: 'center', background: '#fff', borderRadius: 16, padding: '40px 32px', boxShadow: '0 4px 24px rgba(0,0,0,0.10)', border: '1.5px solid #ffccc7' }}>
        <div style={{ fontSize: 56, marginBottom: 16 }}>🚫</div>
        <div style={{ fontSize: 20, fontWeight: 800, color: '#cf1322', marginBottom: 12 }}>
          खाता निष्क्रिय कर दिया गया है
        </div>
        <div style={{ fontSize: 14, color: '#595959', lineHeight: 1.8, marginBottom: 24 }}>
          आपका ABRSVS सदस्य खाता निष्क्रिय कर दिया गया है।<br />
          अधिक जानकारी के लिए कृपया ABRSVS कार्यालय से संपर्क करें।
        </div>
        <div style={{ fontSize: 13, color: '#8c8c8c', marginBottom: 24 }}>
          <strong>Account Deactivated</strong><br />
          Your ABRSVS member account has been deactivated.<br />
          Please contact the ABRSVS office for more information.
        </div>
        <a href="tel:+91XXXXXXXXXX" style={{ display: 'block', background: '#cf1322', color: '#fff', borderRadius: 10, padding: '12px 0', fontWeight: 700, fontSize: 15, textDecoration: 'none', marginBottom: 10 }}>
          📞 संपर्क करें / Contact Us
        </a>
        <button
          onClick={() => history.push('/user-portal-login')}
          style={{ width: '100%', background: '#f5f5f5', color: '#595959', border: '1px solid #d9d9d9', borderRadius: 10, padding: '10px 0', fontWeight: 600, fontSize: 14, cursor: 'pointer' }}
        >
          Login Page पर जाएं
        </button>
      </div>
    </div>
  );

  return (
    <LangCtx.Provider value={{ lang, setLang, t }}>
    <div style={{ minHeight: '100vh', background: BG, fontFamily: "'Segoe UI', 'Noto Sans Devanagari', sans-serif" }}>

      {/* ── WHITE HEADER ── */}
      <div style={{
        background: '#fff',
        borderBottom: `3px solid ${M}`,
        padding: '14px 20px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          {(profile?.photo || memberInfo.photo)
            ? <img src={profile?.photo || memberInfo.photo} alt="profile"
                style={{ width: 48, height: 48, borderRadius: '50%', objectFit: 'cover',
                  border: `2.5px solid ${M}`, objectPosition: 'top center' }} />
            : <div style={{ width: 48, height: 48, borderRadius: '50%', background: M,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 16, fontWeight: 800, color: G, border: `2px solid ${G}`, flexShrink: 0 }}>
                {(memberName || '?').trim().split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase()}
              </div>
          }
          <div>
            <div style={{ fontSize: 15, fontWeight: 800, color: M, lineHeight: 1.2 }}>
              {memberInfo.name || memberName || 'Member'}
            </div>
            <div style={{ fontSize: 11, color: '#6b7280', marginTop: 1, display: 'flex', alignItems: 'center', gap: 5, flexWrap: 'wrap' }}>
              {t('अखिल भारतीय राजपुरोहित समाज विकास संस्थान', 'Akhil Bharatiya Rajpurohit Samaj Vikas Sansthan')}
              {memberNo && <span style={{ color: M, fontWeight: 600 }}>· #{memberNo}</span>}
              {(() => { const cf = countryFlag(profile?.temp_address?.country || profile?.current_country); return cf?.isAbroad ? <span style={{ fontSize: 16 }}>{cf.flag}</span> : null; })()}
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {/* Quick Refer button */}
          {isSNUser && (
            <button onClick={quickShare} title="WhatsApp पर आमंत्रण भेजें" style={{
              background: '#25d366', border: 'none', borderRadius: 8,
              height: 34, cursor: 'pointer', color: '#fff',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              gap: 5, padding: '0 10px', fontSize: 12, fontWeight: 700,
              boxShadow: '0 2px 6px rgba(37,211,102,0.35)',
            }}>
              <UsergroupAddOutlined style={{ fontSize: 15 }} />
              <span style={{ display: mobile ? 'none' : 'inline' }}>Refer</span>
            </button>
          )}
          <Badge count={unreadCount} overflowCount={99} size="small">
            <button onClick={() => setNotifOpen(true)} style={{
              background: unreadCount > 0 ? '#fff9f0' : '#f9fafb',
              border: `1.5px solid ${unreadCount > 0 ? G : '#e5e7eb'}`,
              borderRadius: 10, width: 36, height: 36, cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <BellFilled style={{ fontSize: 18, color: unreadCount > 0 ? M : '#9ca3af' }} />
            </button>
          </Badge>
          {/* Language Toggle */}
          <button
            onClick={() => setLang(lang === 'hi' ? 'en' : 'hi')}
            title={lang === 'hi' ? 'Switch to English' : 'हिंदी में बदलें'}
            style={{
              background: lang === 'en' ? M : '#fff',
              border: `1.5px solid ${M}`, borderRadius: 8,
              height: 34, padding: '0 10px', cursor: 'pointer',
              color: lang === 'en' ? '#fff' : M,
              fontSize: 12, fontWeight: 800, letterSpacing: 0.5,
              display: 'flex', alignItems: 'center', gap: 4,
            }}>
            <GlobalOutlined style={{ fontSize: 13 }} />
            {lang === 'hi' ? 'EN' : 'हिं'}
          </button>
          <button onClick={() => Modal.confirm({
            title: 'लॉगआउट करें?',
            content: 'क्या आप पोर्टल से बाहर जाना चाहते हैं?',
            okText: 'हाँ, लॉगआउट करें',
            cancelText: 'रहने देवें',
            okButtonProps: { danger: true },
            onOk: logout,
          })} title="Logout" style={{
            background: '#fff5f5', border: `1.5px solid ${M}`, borderRadius: 8,
            width: 34, height: 34, cursor: 'pointer', color: M,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <LogoutOutlined style={{ fontSize: 16 }} />
          </button>
        </div>
      </div>

      <NotificationPanel
        open={notifOpen}
        onClose={() => setNotifOpen(false)}
        onCountChange={setUnreadCount}
      />

      {/* ── FESTIVAL CELEBRATION ── */}
      {festival && (
        <FestivalCelebration festival={festival} onClose={() => setFestival(null)} />
      )}

      {/* ── BIRTHDAY CELEBRATION ── */}
      {bdayCelebration && (
        <BirthdayCelebration
          name={profile?.name_hn || profile?.name_eng || profile?.name || 'आप'}
          onClose={() => setBdayCelebration(false)}
        />
      )}

      {/* ── REFERRER PROMPT MODAL ── */}
      {referrerPrompt && (
        <ReferrerPromptModal
          profile={profile}
          onClose={() => {
            localStorage.setItem(`referrerPromptDone_${profile?.id}`, '1');
            setReferrerPrompt(false);
          }}
          onDone={() => {
            localStorage.setItem(`referrerPromptDone_${profile?.id}`, '1');
            setReferrerPrompt(false); fetchProfile();
          }}
        />
      )}

      {/* ── BIRTHDAY STRIP ── */}
      {!birthdayDismissed && birthdays.length > 0 && !birthdays.every(b => b.already_wished) && (
        <div style={{
          background: 'linear-gradient(90deg, #7a0000 0%, #b71c1c 40%, #c97900 100%)',
          padding: '0 10px',
          display: 'flex', alignItems: 'center', gap: 8,
          borderBottom: '2px solid #fcd34d',
          position: 'relative',
          minHeight: 60,
        }}>
          {/* Label — single compact line */}
          <div style={{ flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, minWidth: 30 }}>
            <span style={{ fontSize: 17, lineHeight: 1 }}>🌸</span>
            <span style={{ fontSize: 7, fontWeight: 800, color: G, whiteSpace: 'nowrap', lineHeight: 1 }}>{birthdays.length} जन्मदिन</span>
          </div>

          {/* Horizontal scroll of birthday cards */}
          <div style={{
            flex: 1, display: 'flex', gap: 6, overflowX: 'auto', scrollbarWidth: 'none',
            padding: '6px 0',
          }}>
            {birthdays.map(b => {
              const initials = (n) => (n || '?').trim().split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();
              return (
                <button
                  key={b.id}
                  onClick={() => setWishPerson(b)}
                  style={{
                    flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'center',
                    background: b.already_wished ? 'rgba(21,128,61,0.3)' : 'rgba(255,255,255,0.12)',
                    border: `1.5px solid ${b.already_wished ? '#86efac' : 'rgba(255,215,0,0.4)'}`,
                    borderRadius: 8, padding: '4px 8px', cursor: 'pointer',
                    minWidth: 58, gap: 3,
                    transition: 'all 0.15s',
                  }}>
                  <div style={{ position: 'relative' }}>
                    {b.photo ? (
                      <>
                        <img
                          src={b.photo} alt=""
                          onError={e => {
                            e.target.style.display = 'none';
                            e.target.nextElementSibling.style.display = 'flex';
                          }}
                          style={{ width: 32, height: 32, borderRadius: '50%', objectFit: 'cover',
                            objectPosition: 'top', display: 'block',
                            border: `2px solid ${b.already_wished ? '#86efac' : G}` }}
                        />
                        <div style={{ display: 'none', width: 32, height: 32, borderRadius: '50%',
                          background: 'rgba(255,215,0,0.2)', border: `2px solid ${G}`,
                          alignItems: 'center', justifyContent: 'center',
                          fontSize: 11, fontWeight: 800, color: G }}>
                          {initials(b.name)}
                        </div>
                      </>
                    ) : (
                      <div style={{ width: 32, height: 32, borderRadius: '50%',
                        background: 'rgba(255,215,0,0.2)', border: `2px solid ${G}`,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: 11, fontWeight: 800, color: G }}>
                        {initials(b.name)}
                      </div>
                    )}
                    <span style={{ position: 'absolute', bottom: -2, right: -2, fontSize: 11 }}>
                      {b.already_wished ? '✅' : '🌸'}
                    </span>
                  </div>
                  <div style={{ fontSize: 8, fontWeight: 700, color: '#fff', textAlign: 'center',
                    maxWidth: 50, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', lineHeight: 1.2 }}>
                    {b.name?.split(' ')[0]}
                  </div>
                  {lastSeen(b.last_active_at)?.online && (
                    <div style={{ width: 7, height: 7, borderRadius: '50%', background: '#22c55e',
                      border: '1.5px solid #fff', marginTop: 1, alignSelf: 'center' }} />
                  )}
                </button>
              );
            })}
          </div>

          {/* Dismiss */}
          <button onClick={() => setBirthdayDismissed(true)} style={{
            flexShrink: 0, background: 'rgba(255,255,255,0.1)', border: 'none',
            color: 'rgba(255,255,255,0.6)', borderRadius: '50%', width: 22, height: 22,
            cursor: 'pointer', fontSize: 14, display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>×</button>
        </div>
      )}

      {/* ── BIRTHDAY WISH MINI MODAL ── */}
      {wishPerson && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 1300,
          display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
        }} onClick={e => { if (e.target === e.currentTarget) setWishPerson(null); }}>
          <div style={{
            background: 'linear-gradient(160deg, #fff9f0, #fffbeb)',
            borderRadius: 18, padding: '28px 24px', textAlign: 'center',
            maxWidth: 300, width: '100%',
            border: '2px solid #fcd34d', boxShadow: '0 8px 40px rgba(0,0,0,0.25)',
          }}>
            <div style={{ fontSize: 36, marginBottom: 10 }}>🌸</div>
            <div style={{ position: 'relative', display: 'inline-block', marginBottom: 12 }}>
              {wishPerson.photo ? (
                <>
                  <img
                    src={wishPerson.photo} alt=""
                    onError={e => {
                      e.target.style.display = 'none';
                      e.target.nextElementSibling.style.display = 'flex';
                    }}
                    style={{ width: 72, height: 72, borderRadius: '50%', objectFit: 'cover',
                      objectPosition: 'top', border: '3px solid #fcd34d', display: 'block' }}
                  />
                  <div style={{ display: 'none', width: 72, height: 72, borderRadius: '50%',
                    background: '#fef3c7', border: '3px solid #fcd34d',
                    alignItems: 'center', justifyContent: 'center',
                    fontSize: 22, fontWeight: 800, color: '#92400e' }}>
                    {(wishPerson.name || '?').trim().split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase()}
                  </div>
                </>
              ) : (
                <div style={{ width: 72, height: 72, borderRadius: '50%', background: '#fef3c7',
                  border: '3px solid #fcd34d', margin: '0 auto',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 22, fontWeight: 800, color: '#92400e' }}>
                  {(wishPerson.name || '?').trim().split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase()}
                </div>
              )}
            </div>
            <div style={{ fontSize: 16, fontWeight: 800, color: '#92400e', marginBottom: 2 }}>{wishPerson.name}</div>
            {wishPerson.father_name && (
              <div style={{ fontSize: 11, color: '#b45309', marginBottom: 2 }}>पिता: {wishPerson.father_name}</div>
            )}
            <div style={{ fontSize: 11, color: '#9ca3af', marginBottom: 16 }}>
              {[wishPerson.village, wishPerson.tahsil, wishPerson.district].filter(Boolean).join(', ')}
            </div>

            {wishPerson.already_wished ? (
              <div style={{ background: '#dcfce7', borderRadius: 10, padding: '10px 16px',
                fontSize: 13, fontWeight: 700, color: '#15803d' }}>
                ✅ शुभकामनाएं भेजी जा चुकी हैं
              </div>
            ) : (
              <button
                onClick={() => sendBirthdayWish(wishPerson.id)}
                disabled={!!sendingWish[wishPerson.id]}
                style={{
                  width: '100%', background: 'linear-gradient(135deg, #92400e, #b45309)',
                  border: 'none', borderRadius: 12, color: '#fff',
                  padding: '12px 0', fontSize: 14, fontWeight: 800, cursor: 'pointer',
                  opacity: sendingWish[wishPerson.id] ? 0.7 : 1,
                  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                }}>
                {sendingWish[wishPerson.id] ? <LoadingOutlined /> : '🌸'}
                जन्मदिन की हार्दिक शुभकामनाएं भेजें
              </button>
            )}
            <button onClick={() => setWishPerson(null)}
              style={{ marginTop: 10, background: 'none', border: 'none', fontSize: 12,
                color: '#9ca3af', cursor: 'pointer' }}>
              बाद में
            </button>
          </div>
        </div>
      )}

      {/* ── TAB BAR ── */}
      <div style={{
        background: '#fff',
        borderBottom: '1px solid #e5e7eb',
        position: 'sticky', top: 0, zIndex: 200,
        boxShadow: '0 2px 10px rgba(0,0,0,0.07)',
      }}>
        <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>

          {/* Left scroll arrow */}
          {canScrollLeft && (
            <button onClick={() => scrollTabs(-1)} style={{
              position: 'absolute', left: 0, zIndex: 10, height: '100%',
              width: 32, border: 'none', cursor: 'pointer',
              background: 'linear-gradient(to right, #fff 60%, transparent)',
              display: 'flex', alignItems: 'center', justifyContent: 'flex-start',
              paddingLeft: 6, color: '#6b7280', flexShrink: 0,
            }}>
              <LeftOutlined style={{ fontSize: 11, fontWeight: 700 }} />
            </button>
          )}

          {/* Scrollable tab strip */}
          <div
            ref={tabBarRef}
            style={{
              display: 'flex', overflowX: 'auto', flex: 1,
              scrollbarWidth: 'none', msOverflowStyle: 'none',
              padding: '6px 8px',
              gap: 2,
            }}>
            <style>{`.portal-tabbar::-webkit-scrollbar{display:none}`}</style>

            {PROFILE_TABS.map(tab => {
              const badge   = tabBadges[tab.key] || 0;
              const locked  = isTabLocked(tab.key);
              const isActive = activeTab === tab.key;
              return (
                <button
                  key={tab.key}
                  data-active={isActive}
                  onClick={() => locked ? switchTab('payments') : switchTab(tab.key)}
                  title={locked ? 'Account inactive — payment करें' : tab.label}
                  style={{
                    display: 'flex', flexDirection: 'column', alignItems: 'center',
                    gap: 3, padding: '6px 12px 5px',
                    border: 'none', borderRadius: 10, flexShrink: 0,
                    cursor: locked ? 'not-allowed' : 'pointer',
                    position: 'relative',
                    minWidth: 52,
                    background: isActive ? M : 'transparent',
                    color: locked ? '#d1d5db' : isActive ? '#fff' : '#6b7280',
                    fontSize: 10, fontWeight: isActive ? 700 : 500,
                    opacity: locked ? 0.45 : 1,
                    transition: 'background 0.18s, color 0.18s, transform 0.12s',
                    transform: isActive ? 'translateY(-1px)' : 'none',
                    boxShadow: isActive ? `0 3px 10px ${M}55` : 'none',
                  }}>
                  {/* Icon + badge */}
                  <span style={{ fontSize: 16, position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', lineHeight: 1 }}>
                    {locked ? <LockOutlined style={{ fontSize: 14 }} /> : tab.icon}
                    {!locked && badge > 0 && (
                      <span style={{
                        position: 'absolute', top: -5, right: -7,
                        background: '#ef4444', color: '#fff',
                        fontSize: 8, fontWeight: 800, borderRadius: '50%',
                        width: 14, height: 14,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        lineHeight: 1, boxShadow: '0 1px 4px rgba(0,0,0,0.35)',
                        border: '1.5px solid #fff',
                      }}>
                        {badge > 9 ? '9+' : badge}
                      </span>
                    )}
                  </span>

                  {/* Label */}
                  <span style={{ whiteSpace: 'nowrap', letterSpacing: 0.1 }}>{tab.label}</span>

                  {/* Sub-badge (ABRSVS / SN-ABRSVS) */}
                  {(tab.key === 'community' || tab.key === 'payments') && (
                    <span style={{
                      background: isActive ? 'rgba(255,255,255,0.25)' : M,
                      color: isActive ? '#fff' : G,
                      fontSize: 7, fontWeight: 900,
                      borderRadius: 3, padding: '1px 4px',
                      letterSpacing: 0.4, lineHeight: 1.5, marginTop: -1,
                    }}>
                      {tab.key === 'community' ? 'ABRSVS' : 'SN-ABRSVS'}
                    </span>
                  )}
                </button>
              );
            })}

          </div>

          {/* Right scroll arrow */}
          {canScrollRight && (
            <button onClick={() => scrollTabs(1)} style={{
              position: 'absolute', right: 0, zIndex: 10, height: '100%',
              width: 32, border: 'none', cursor: 'pointer',
              background: 'linear-gradient(to left, #fff 60%, transparent)',
              display: 'flex', alignItems: 'center', justifyContent: 'flex-end',
              paddingRight: 6, color: '#6b7280', flexShrink: 0,
            }}>
              <RightOutlined style={{ fontSize: 11, fontWeight: 700 }} />
            </button>
          )}
        </div>
      </div>

      {/* ── BUSINESS DIRECTORY STRIP — below tab bar ── */}
      {showBizDir && (
        <button
          onClick={() => switchTab('biz-directory')}
          style={{
            width: '100%', border: 'none', cursor: 'pointer',
            display: 'flex', alignItems: 'center', gap: 10,
            padding: '7px 16px',
            background: activeTab === 'biz-directory'
              ? `linear-gradient(90deg, ${M} 0%, #b71c1c 100%)`
              : 'linear-gradient(90deg, #fdf6e3 0%, #fef3c7 100%)',
            borderTop: '1px solid #fde68a',
            borderBottom: '1px solid #fde68a',
            transition: 'background 0.18s',
          }}>
          <AppstoreOutlined style={{
            fontSize: 14,
            color: activeTab === 'biz-directory' ? G : M,
          }} />
          <span style={{
            fontSize: 12, fontWeight: 700,
            color: activeTab === 'biz-directory' ? '#fff' : M,
            flex: 1, textAlign: 'left',
          }}>
            {t('सामुदायिक व्यापार निर्देशिका', 'Community Business Directory')}
          </span>
          <span style={{
            fontSize: 10, fontWeight: 800,
            background: activeTab === 'biz-directory' ? 'rgba(255,215,0,0.25)' : M,
            color: activeTab === 'biz-directory' ? G : '#fff',
            borderRadius: 20, padding: '2px 10px', letterSpacing: 0.5,
          }}>
            Community
          </span>
        </button>
      )}

      {/* ── CONTENT ── */}
      <div style={{ maxWidth: mobile ? '100%' : 720, margin: '0 auto', padding: mobile ? '14px 12px 90px' : '20px 20px 90px' }}>

        {/* ── INACTIVE BANNER — always visible at top when inactive ── */}
        {isSNUser && !isActive && (
          <div style={{
            background: 'linear-gradient(135deg, #92400e 0%, #b45309 100%)',
            borderRadius: 14, padding: '14px 16px', marginBottom: 14,
            display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12,
          }}>
            <div>
              <div style={{ fontSize: 12, fontWeight: 800, color: '#fde68a', marginBottom: 2 }}>
                🔒 Account Inactive
              </div>
              <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.85)' }}>
                Payment करने के बाद सभी features automatically unlock होंगे।
              </div>
            </div>
            <button onClick={() => switchTab('payments')} style={{
              background: '#fde68a', color: '#92400e', border: 'none',
              borderRadius: 8, padding: '9px 14px', fontSize: 12, fontWeight: 900,
              cursor: 'pointer', whiteSpace: 'nowrap', flexShrink: 0,
            }}>
              Payment करें →
            </button>
          </div>
        )}

        {/* ── LOCKED TAB OVERLAY ── for inactive members on non-accessible tabs ── */}
        {isTabLocked(activeTab) && (
          <div style={{
            position: 'relative', minHeight: 200,
            display: 'flex', flexDirection: 'column', alignItems: 'center',
            justifyContent: 'center', textAlign: 'center', padding: 32,
            background: '#f9fafb', borderRadius: 14, marginBottom: 14,
            border: '2px dashed #e5e7eb',
          }}>
            <div style={{ fontSize: 36, marginBottom: 10 }}>🔒</div>
            <div style={{ fontSize: 15, fontWeight: 800, color: '#374151', marginBottom: 6 }}>
              यह feature active members के लिए है
            </div>
            <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 18, lineHeight: 1.7 }}>
              Shiksha Nidhi payment करने के बाद<br />यह section automatically unlock हो जाएगा।
            </div>
            <button onClick={() => switchTab('payments')} style={{
              background: M, color: G, border: 'none',
              borderRadius: 10, padding: '11px 24px', fontSize: 13, fontWeight: 800, cursor: 'pointer',
            }}>
              अभी Payment करें →
            </button>
          </div>
        )}

        {/* ── Email collection banner ── */}
        {emailPrompt && (
          <div style={{
            background: 'linear-gradient(135deg,#7a0000,#b71c1c)', borderRadius: 12,
            padding: '12px 14px', marginBottom: 12,
            display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap',
            boxShadow: '0 2px 12px rgba(122,0,0,0.25)',
          }}>
            <div style={{ fontSize: 22, flexShrink: 0 }}>📧</div>
            <div style={{ flex: 1, minWidth: 180 }}>
              <div style={{ fontSize: 12, fontWeight: 800, color: '#fff', marginBottom: 2 }}>
                Email जोड़ें — Chat notifications पाएं
              </div>
              <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.8)' }}>
                जब कोई आपको message करे तो email पर notification मिलेगी
              </div>
            </div>
            <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexShrink: 0 }}>
              <input
                type="email"
                value={emailInput}
                onChange={e => setEmailInput(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && saveEmail()}
                placeholder="आपका email address"
                style={{
                  padding: '6px 10px', borderRadius: 8, border: '1.5px solid rgba(255,255,255,0.4)',
                  fontSize: 12, background: 'rgba(255,255,255,0.15)', color: '#fff',
                  outline: 'none', width: 190,
                  '::placeholder': { color: 'rgba(255,255,255,0.6)' },
                }}
              />
              <button onClick={saveEmail} disabled={emailSaving}
                style={{ background: '#FFD700', color: '#7a0000', border: 'none', borderRadius: 8, padding: '6px 12px', fontSize: 12, fontWeight: 800, cursor: 'pointer', flexShrink: 0, whiteSpace: 'nowrap' }}>
                {emailSaving ? '…' : 'Save'}
              </button>
              <button onClick={() => { setEmailPrompt(false); sessionStorage.setItem('emailPromptDismissed', '1'); }}
                style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff', borderRadius: 8, padding: '6px 10px', fontSize: 11, cursor: 'pointer', whiteSpace: 'nowrap' }}>
                बाद में
              </button>
            </div>
          </div>
        )}

        {activeTab === 'home'       && <HomeDashboardTab profile={profile} onSwitchTab={switchTab} tabBadges={tabBadges} onlineUsers={homeOnlineUsers} onChatOpen={id => { const u = homeOnlineUsers.find(x => x.id === id); setChatOpenTargetData(u || null); setChatOpenTarget(id); switchTab('chat'); }} onQuickPay={() => { switchTab('payments'); setQuickPayTrigger(t => t + 1); }} />}

        {activeTab === 'profile'    && <ProfileTab profile={profile} onUpdated={() => fetchProfile(true)} />}
        {activeTab === 'profile'    && profile && <MembershipCard profile={profile} />}
        {activeTab === 'payments'   && <PaymentsTab quickPayTrigger={quickPayTrigger} joiningDate={profile?.joining_date} />}

        {/* ── Verified Business + not in Mission 21K → prompt ── */}
        {activeTab === 'business' && isSNUser && bizVerified && !missionEnrolled && (
          <div style={{
            background: 'linear-gradient(135deg, #92400e 0%, #b45309 100%)',
            borderRadius: 14, padding: '14px 16px', marginBottom: 14,
            display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12,
          }}>
            <div>
              <div style={{ fontSize: 12, fontWeight: 800, color: '#fde68a', marginBottom: 2 }}>
                🎯 आपका Business verified है!
              </div>
              <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.8)' }}>
                Mission 21K या Shiksha Nidhi से जुड़कर community को support करें।
              </div>
            </div>
            <button onClick={() => switchTab('payments')} style={{
              background: '#fde68a', color: '#92400e', border: 'none',
              borderRadius: 8, padding: '8px 14px', fontSize: 12, fontWeight: 800,
              cursor: 'pointer', whiteSpace: 'nowrap', flexShrink: 0,
            }}>
              जुड़ें →
            </button>
          </div>
        )}
        {activeTab === 'business'   && <MyBusinessTab profile={profile} onUpdated={fetchProfile} />}
        {/* Family and Social Status are now managed inside Profile tab */}
        {activeTab === 'development' && <DevelopmentTab initialSubTab={devInitialSubTab} />}
        {activeTab === 'community'   && <CombinedContributionTab profile={profile} />}
        {activeTab === 'contacts'    && <MyContactsTab profile={profile} onSwitchTab={switchTab} />}
        {activeTab === 'board'       && <CommunityBoardTab profile={profile} onSwitchTab={switchTab} initMyView={boardInitMyView} onInitMyViewDone={() => setBoardInitMyView(false)} />}
        {/* ── New tabs ── */}
        {activeTab === 'samachar'    && <AnnouncementsTab />}
        {/* {activeTab === 'samaj'       && <SamajTab />} */}
        {activeTab === 'directory'   && <CombinedMembersTab profile={profile} onSwitchTab={switchTab} />}
        {/* yogdan merged into community tab */}
        {/* Always keep MemberChatTab mounted so socket stays alive and messages don't reload on every tab switch */}
        <div style={{ display: activeTab === 'chat' ? 'block' : 'none' }}>
          <MemberChatTab profile={profile} onSwitchTab={switchTab} isVisible={activeTab === 'chat'} openChatWith={chatOpenTarget} openChatWithData={chatOpenTargetData} onChatOpened={() => { setChatOpenTarget(null); setChatOpenTargetData(null); }}
            onNewMessage={(msgData) => {
              setTabBadges(prev => ({ ...prev, chat: (prev.chat || 0) + 1 }));
              if (msgData) {
                setFloatChatPreview(msgData);
                clearTimeout(floatPreviewTimer.current);
                floatPreviewTimer.current = setTimeout(() => setFloatChatPreview(null), 6000);
              }
            }}
            onChatRequest={(req) => {
              setTabBadges(prev => ({ ...prev, chat: (prev.chat || 0) + 1 }));
              setIncomingRequest(req);
            }} />
        </div>
        {activeTab === 'seva'        && <InquiryTab />}
        {activeTab === 'jobs'          && <JobsTab profile={profile} />}
        {activeTab === 'referral'      && <ReferralTab profile={profile} />}
        {activeTab === 'gallery'       && <GalleryTab />}
        {/* Jobs moved into Services tab */}
        {activeTab === 'student-help'  && <StudentSupportTab />}
        {activeTab === 'services'      && <CombinedServicesTab profile={profile} initialSub={servicesInitialSub} onOpenChat={id => { setChatOpenTarget(id); switchTab('chat'); }} />}
        {/* City Community merged into Members tab */}
        {activeTab === 'villages'      && <VillageDirectoryTab defaultVillage={profile?.perm_address?.village || ''} />}
        {activeTab === 'janganana'     && <MyFamilyRecordTab />}
        {/* Directory-only member: join banner + biz-directory */}
        {!isSNUser && (
          <>
            <div style={{ background: 'linear-gradient(135deg,#7a0000,#b71c1c)', borderRadius: 14, padding: '14px 16px', marginBottom: 14, display: 'flex', alignItems: 'center', gap: 12 }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13, fontWeight: 900, color: '#FFD700' }}>{t('ABRSVS का पूर्ण सदस्य बनें 🙏', 'Become a Full ABRSVS Member 🙏')}</div>
                <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.8)', marginTop: 3 }}>
                  {t('सदस्यता बने — Community Board, News, Members और सभी सुविधाएं मिलेंगी',
                     'Pay membership — unlock Community Board, News, Members & all features')}
                </div>
              </div>
              <button onClick={() => setShowJoinModal(true)}
                style={{ background: '#FFD700', color: '#7a0000', border: 'none', borderRadius: 10, padding: '10px 16px', fontSize: 12, fontWeight: 900, cursor: 'pointer', whiteSpace: 'nowrap', flexShrink: 0 }}>
                {t('सदस्य बनें →', 'Join Now →')}
              </button>
            </div>
            <DirectoryTab myEntryId={myEntryId} profile={profile} onSwitchTab={switchTab} />
          </>
        )}
        {isSNUser && activeTab === 'biz-directory' && <DirectoryTab myEntryId={myEntryId} profile={profile} onSwitchTab={switchTab} />}
      </div>

      {showJoinModal && !isSNUser && profile && (
        <BecomeMemberModal
          profile={profile.result || profile}
          onClose={() => setShowJoinModal(false)}
          onSuccess={() => { setShowJoinModal(false); window.location.reload(); }}
        />
      )}
    </div>

    {/* ── Incoming chat request dialog ─────────────────────────────────────── */}
    {incomingRequest && (
      <div style={{
        position: 'fixed', bottom: 80, left: '50%', transform: 'translateX(-50%)',
        zIndex: 1400, width: 320, maxWidth: 'calc(100vw - 32px)',
        background: '#fff', borderRadius: 16,
        boxShadow: '0 8px 32px rgba(0,0,0,0.22)', border: `2px solid ${M}`,
        overflow: 'hidden', animation: 'reqSlideUp 0.3s ease',
      }}>
        <style>{`@keyframes reqSlideUp { from { opacity:0; transform:translateX(-50%) translateY(20px); } to { opacity:1; transform:translateX(-50%) translateY(0); } }`}</style>
        {/* Header */}
        <div style={{ background: `linear-gradient(135deg,${M},#b71c1c)`, padding: '10px 14px', display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#22c55e', flexShrink: 0, boxShadow: '0 0 0 2px rgba(34,197,94,0.4)', animation: 'reqPulse 1.2s ease-in-out infinite' }} />
          <style>{`@keyframes reqPulse { 0%,100%{transform:scale(1)}50%{transform:scale(1.4)} }`}</style>
          <span style={{ fontSize: 12, fontWeight: 800, color: '#fff', flex: 1 }}>💬 नया Message Request</span>
          <button onClick={() => setIncomingRequest(null)}
            style={{ background: 'rgba(255,255,255,0.2)', border: 'none', color: '#fff', width: 22, height: 22, borderRadius: '50%', cursor: 'pointer', fontSize: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            ×
          </button>
        </div>
        {/* Sender info */}
        <div style={{ padding: '12px 14px 8px', display: 'flex', alignItems: 'center', gap: 10 }}>
          {incomingRequest.sender_photo
            ? <img src={incomingRequest.sender_photo} alt="" style={{ width: 42, height: 42, borderRadius: '50%', objectFit: 'cover', flexShrink: 0, border: `2px solid ${M}` }} />
            : <div style={{ width: 42, height: 42, borderRadius: '50%', background: M, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 900, color: '#fff', flexShrink: 0 }}>
                {(incomingRequest.sender_name || '?').trim().slice(0, 2).toUpperCase()}
              </div>
          }
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 13, fontWeight: 800, color: '#1c1e21', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {incomingRequest.sender_name || 'कोई सदस्य'}
            </div>
            <div style={{ fontSize: 11, color: '#6b7280', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', marginTop: 2 }}>
              {(incomingRequest.message || 'आपसे बात करना चाहते हैं').slice(0, 60)}
            </div>
          </div>
        </div>
        {/* Action buttons */}
        <div style={{ display: 'flex', gap: 8, padding: '8px 14px 14px' }}>
          <button
            onClick={async () => {
              const req = incomingRequest;
              setIncomingRequest(null);
              try {
                await axios.patch(`${baseUrl}/member/chat/request/${req.from_user_id}/accept`, {}, { headers: authHeader() });
              } catch {}
              setChatOpenTargetData({ id: req.from_user_id, name: req.sender_name, photo: req.sender_photo, village: '' });
              setChatOpenTarget(String(req.from_user_id));
              switchTab('chat');
            }}
            style={{ flex: 1, background: '#15803d', color: '#fff', border: 'none', borderRadius: 10, padding: '9px 0', fontSize: 12, fontWeight: 800, cursor: 'pointer' }}>
            ✓ Accept &amp; Chat
          </button>
          <button
            onClick={async () => {
              const req = incomingRequest;
              setIncomingRequest(null);
              try {
                await axios.patch(`${baseUrl}/member/chat/request/${req.from_user_id}/decline`, {}, { headers: authHeader() });
              } catch {}
            }}
            style={{ flex: 1, background: '#f3f4f6', color: '#6b7280', border: '1px solid #e5e7eb', borderRadius: 10, padding: '9px 0', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>
            ✕ Decline
          </button>
        </div>
      </div>
    )}

    {/* ── Floating chat button — right side, hidden on chat tab ── */}
    {isSNUser && activeTab !== 'chat' && (
      <div style={{
        position: 'fixed', bottom: 80, right: 10, zIndex: 1200,
      }}>
        {/* Messenger */}
        <div style={{ position: 'relative' }}>
          {floatChatPreview && (
            <div style={{
              position: 'absolute', right: 46, top: '50%', transform: 'translateY(-50%)',
              background: '#fff', borderRadius: 12, boxShadow: '0 4px 20px rgba(0,0,0,0.18)',
              padding: '8px 10px', width: 220, border: '1px solid #e4e6eb',
              display: 'flex', flexDirection: 'column', gap: 4, zIndex: 1300,
              animation: 'slideInPreview 0.25s ease',
            }}>
              <style>{`@keyframes slideInPreview { from { opacity:0; transform:translateY(-50%) translateX(10px); } to { opacity:1; transform:translateY(-50%) translateX(0); } }`}</style>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                {floatChatPreview.sender_photo
                  ? <img src={floatChatPreview.sender_photo} alt="" style={{ width: 26, height: 26, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }} />
                  : <div style={{ width: 26, height: 26, borderRadius: '50%', background: '#7c3aed', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 9, fontWeight: 800, color: '#fff', flexShrink: 0 }}>
                      {(floatChatPreview.sender_name || '?').trim().slice(0, 2).toUpperCase()}
                    </div>
                }
                <div style={{ fontWeight: 700, fontSize: 11, color: '#1c1e21', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1 }}>
                  {floatChatPreview.sender_name || 'New message'}
                </div>
                <button onClick={() => setFloatChatPreview(null)}
                  style={{ background: 'none', border: 'none', fontSize: 13, color: '#9ca3af', cursor: 'pointer', lineHeight: 1, padding: 0, flexShrink: 0 }}>×</button>
              </div>
              <div style={{ fontSize: 11, color: '#374151', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {(floatChatPreview.message || '').slice(0, 60)}{floatChatPreview.message?.length > 60 ? '…' : ''}
              </div>
              <button
                onClick={() => { setFloatChatPreview(null); switchTab('chat'); }}
                style={{ background: '#7c3aed', color: '#fff', border: 'none', borderRadius: 8, padding: '4px 0', fontSize: 11, fontWeight: 700, cursor: 'pointer', marginTop: 2 }}>
                💬 Reply
              </button>
            </div>
          )}
          <button onClick={() => { setFloatChatPreview(null); switchTab('chat'); }} title="Messenger"
            style={{
              width: 40, height: 40, borderRadius: '50%',
              background: '#7c3aed', color: '#fff', border: 'none', cursor: 'pointer',
              boxShadow: floatChatPreview ? '0 0 0 3px rgba(124,58,237,0.5), 0 3px 10px rgba(124,58,237,0.6)' : '0 3px 10px rgba(124,58,237,0.45)',
              display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 17,
              animation: floatChatPreview ? 'chatPulse 1.2s ease-in-out infinite' : 'none',
            }}>
            <style>{`@keyframes chatPulse { 0%,100% { transform:scale(1); } 50% { transform:scale(1.12); } }`}</style>
            <Badge count={tabBadges.chat} overflowCount={9} size="small"
              style={{ boxShadow: '0 0 0 2px #7c3aed' }}>
              <MessageOutlined style={{ fontSize: 17, color: '#fff' }} />
            </Badge>
          </button>
        </div>
      </div>
    )}

    {/* ── Floating Inquiry button — bottom-left ── */}
    {isSNUser && (
      <button onClick={() => setFloatInquiryOpen(o => !o)} title="Inquiry / सहायता"
        style={{
          position: 'fixed', bottom: 80, left: 16, zIndex: 1200,
          width: 40, height: 40, borderRadius: '50%',
          background: floatInquiryOpen ? '#6b7280' : M,
          color: '#fff', border: 'none', cursor: 'pointer',
          boxShadow: '0 3px 10px rgba(0,0,0,0.25)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 17, transition: 'background 0.2s, transform 0.2s',
          transform: floatInquiryOpen ? 'rotate(45deg)' : 'none',
        }}>
        {floatInquiryOpen ? <CloseOutlined /> : <CustomerServiceOutlined />}
      </button>
    )}

    {/* ── Community Business Directory — left-side floating tab ─────────────── */}
    {/* {isSNUser && (
      <button
        onClick={() => switchTab('biz-directory')}
        title="Community Business Directory"
        style={{
          position: 'fixed', left: 0, top: '50%', transform: 'translateY(-50%)',
          zIndex: 1200, writingMode: 'vertical-rl', textOrientation: 'mixed',
          background: M, color: G, border: 'none', cursor: 'pointer',
          padding: '10px 4px', borderRadius: '0 10px 10px 0',
          fontSize: 11, fontWeight: 800, letterSpacing: 1,
          boxShadow: '2px 0 12px rgba(0,0,0,0.18)',
          display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8,
        }}>
        <span>Community Business</span>
      </button>
    )} */}

    {/* ── Floating Inquiry popup panel ──────────────────────────────────────── */}
    {isSNUser && (
      <>

        {/* Popup panel */}
        {floatInquiryOpen && (
          <div style={{
            position: 'fixed', bottom: 128, left: 16, zIndex: 1199,
            width: 320, background: '#fff',
            borderRadius: 16, boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
            border: '1px solid #e5e7eb', overflow: 'hidden',
          }}>
            {/* Header */}
            <div style={{
              background: `linear-gradient(135deg, ${M} 0%, #b71c1c 100%)`,
              padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 10,
            }}>
              <CustomerServiceOutlined style={{ color: '#FFD700', fontSize: 18 }} />
              <div>
                <div style={{ fontSize: 13, fontWeight: 800, color: '#fff' }}>Inquiry / सहायता</div>
                <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.75)' }}>हम जल्द जवाब देंगे</div>
              </div>
              <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 6 }}>
                <button onClick={() => { setFloatInquiryOpen(false); switchTab('seva'); }}
                  style={{ background: 'rgba(255,255,255,0.15)', border: 'none',
                    color: '#fff', fontSize: 10, fontWeight: 700, borderRadius: 20,
                    padding: '3px 9px', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                  सभी देखें →
                </button>
                <button onClick={() => setFloatInquiryOpen(false)}
                  style={{ background: 'rgba(255,255,255,0.2)', border: 'none', color: '#fff',
                    width: 22, height: 22, borderRadius: '50%', cursor: 'pointer',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, lineHeight: 1, flexShrink: 0 }}>
                  ×
                </button>
              </div>
            </div>

            {/* Form */}
            <div style={{ padding: '14px 16px 16px' }}>
              <select
                value={floatForm.inquiry_type}
                onChange={e => setFloatForm(f => ({ ...f, inquiry_type: e.target.value }))}
                style={{ width: '100%', padding: '7px 10px', borderRadius: 8, border: '1px solid #e5e7eb',
                  fontSize: 12, marginBottom: 8, fontFamily: 'inherit', color: '#374151' }}>
                <option value="General">सामान्य प्रश्न</option>
                <option value="Payment">Payment / भुगतान</option>
                <option value="Technical">Technical Issue</option>
                <option value="Suggestion">सुझाव</option>
                <option value="Complaint">शिकायत</option>
              </select>
              <input
                value={floatForm.subject}
                onChange={e => setFloatForm(f => ({ ...f, subject: e.target.value }))}
                placeholder="विषय (Subject) *"
                style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #e5e7eb',
                  fontSize: 12, marginBottom: 8, fontFamily: 'inherit', boxSizing: 'border-box' }}
              />
              <textarea
                value={floatForm.message}
                onChange={e => setFloatForm(f => ({ ...f, message: e.target.value }))}
                placeholder="अपनी query लिखें… *"
                rows={3}
                style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #e5e7eb',
                  fontSize: 12, marginBottom: 10, fontFamily: 'inherit',
                  resize: 'none', boxSizing: 'border-box' }}
              />
              <button
                disabled={floatSending || !floatForm.subject.trim() || !floatForm.message.trim()}
                onClick={async () => {
                  setFloatSending(true);
                  try {
                    const res = await axios.post(`${baseUrl}/member/inquiry`, floatForm, { headers: authHeader() });
                    if (res.data.status) {
                      notification.success({ message: '✅ Inquiry भेजी गई!', placement: 'topRight' });
                      setFloatForm({ subject: '', message: '', inquiry_type: 'General' });
                      setFloatInquiryOpen(false);
                    }
                  } catch {
                    notification.error({ message: 'Error sending inquiry', placement: 'topRight' });
                  } finally { setFloatSending(false); }
                }}
                style={{
                  width: '100%', background: floatSending ? '#e5e7eb' : M,
                  color: '#fff', border: 'none', borderRadius: 8,
                  padding: '10px', fontSize: 13, fontWeight: 700,
                  cursor: floatSending ? 'not-allowed' : 'pointer',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
                }}>
                {floatSending ? <Spin size="small" /> : <><SendOutlined /> भेजें</>}
              </button>
            </div>
          </div>
        )}
      </>
    )}

      {/* ── Live Payment Flash — personalized if same village ── */}
      {paymentFlash && (() => {
        const myVillage    = profile?.perm_address?.village;
        const isSameVillage = myVillage && paymentFlash.village &&
          paymentFlash.village.trim() === myVillage.trim();
        const cardBg = isSameVillage
          ? 'linear-gradient(135deg, #064e3b 0%, #047857 50%, #065f46 100%)'
          : 'linear-gradient(135deg, #4a0000 0%, #7a0000 40%, #b71c1c 80%, #7a0000 100%)';
        const borderColor = isSameVillage ? 'rgba(52,211,153,0.7)' : 'rgba(255,215,0,0.5)';
        const emoji = isSameVillage ? '🏘️' : '🎉';
        const subLabel = isSameVillage
          ? `आपके गाँव ${paymentFlash.village} से!`
          : 'ने योगदान दिया';
        return (
          <>
            <style>{`
              @keyframes pf-in     { from { transform: translateY(120%) scale(0.9); opacity: 0; } to { transform: translateY(0) scale(1); opacity: 1; } }
              @keyframes pf-shimmer{ 0%,100%{ background-position:-200% center } 50%{ background-position:200% center } }
              @keyframes pf-pulse  { 0%,100%{ box-shadow:0 0 0 0 rgba(255,215,0,0.5) } 50%{ box-shadow:0 0 0 10px rgba(255,215,0,0) } }
              @keyframes pf-green  { 0%,100%{ box-shadow:0 0 0 0 rgba(52,211,153,0.6) } 50%{ box-shadow:0 0 0 12px rgba(52,211,153,0) } }
              .pf-card       { animation: pf-in 0.5s cubic-bezier(0.34,1.56,0.64,1) forwards, pf-pulse 1.4s ease-in-out 0.5s 3; }
              .pf-card-green { animation: pf-in 0.5s cubic-bezier(0.34,1.56,0.64,1) forwards, pf-green 1.4s ease-in-out 0.5s 4; }
              .pf-gold  { background:linear-gradient(90deg,#FFD700,#fff8dc,#FFD700,#c97900,#FFD700); background-size:300% auto; animation:pf-shimmer 2.5s linear infinite; -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text; }
              .pf-green { background:linear-gradient(90deg,#6ee7b7,#fff,#6ee7b7,#10b981,#6ee7b7); background-size:300% auto; animation:pf-shimmer 2.5s linear infinite; -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text; }
            `}</style>
            <div onClick={() => setPaymentFlash(null)} style={{ position: 'fixed', bottom: 80, left: '50%', transform: 'translateX(-50%)', zIndex: 2000, cursor: 'pointer' }}>
              <div className={isSameVillage ? 'pf-card-green' : 'pf-card'} style={{
                background: cardBg, borderRadius: 18, padding: '14px 18px',
                display: 'flex', alignItems: 'center', gap: 12,
                border: `1.5px solid ${borderColor}`,
                boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
                minWidth: 260, maxWidth: 340,
              }}>
                <div style={{ fontSize: 28, flexShrink: 0, lineHeight: 1 }}>{emoji}</div>
                {paymentFlash.photo
                  ? <img src={paymentFlash.photo} alt="" style={{ width: 42, height: 42, borderRadius: '50%', objectFit: 'cover', objectPosition: 'top', border: `2px solid ${isSameVillage ? '#6ee7b7' : '#FFD700'}`, flexShrink: 0 }} />
                  : <div style={{ width: 42, height: 42, borderRadius: '50%', background: 'rgba(255,255,255,0.15)', border: `2px solid ${isSameVillage ? '#6ee7b7' : '#FFD700'}`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 800, color: isSameVillage ? '#6ee7b7' : '#FFD700', flexShrink: 0 }}>
                      {(paymentFlash.name || '?').trim().split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase()}
                    </div>
                }
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 12, fontWeight: 800, color: '#fff', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {paymentFlash.name}
                  </div>
                  <div style={{ fontSize: 11, color: isSameVillage ? '#a7f3d0' : 'rgba(255,255,255,0.75)', marginTop: 1, fontWeight: isSameVillage ? 700 : 400 }}>
                    {subLabel}
                  </div>
                  <div className={isSameVillage ? 'pf-green' : 'pf-gold'} style={{ fontSize: 18, fontWeight: 900, marginTop: 2 }}>
                    ₹{Number(paymentFlash.amount).toLocaleString('hi-IN')}
                  </div>
                </div>
              </div>
            </div>
          </>
        );
      })()}

      {/* ── BOTTOM NAVIGATION BAR ── */}
      {isSNUser && (
        <div style={{
          position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 300,
          display: 'flex', justifyContent: 'center', pointerEvents: 'none',
        }}>
          <div style={{
            width: '100%', maxWidth: 720, pointerEvents: 'all',
            background: '#fff',
            borderTop: `2px solid ${M}20`,
            boxShadow: '0 -4px 24px rgba(0,0,0,0.13)',
            display: 'flex',
            paddingBottom: 'env(safe-area-inset-bottom, 0px)',
          }}>
            {[
              { key: 'home',      label: t('होम',     'Home'),    icon: <HomeOutlined />,         badge: 0 },
              { key: 'directory', label: t('सदस्य',   'Members'), icon: <TeamOutlined />,          badge: tabBadges.contacts || 0 },
              { key: 'chat',      label: t('चैट',     'Chat'),    icon: <MessageOutlined />,       badge: tabBadges.chat || 0 },
              { key: 'board',     label: t('मंच',     'Board'),   icon: <CrownOutlined />,         badge: tabBadges.board || 0 },
              { key: 'profile',   label: t('प्रोफ़ाइल','Profile'), icon: <UserOutlined />,          badge: 0 },
            ].map(item => {
              const isActive = activeTab === item.key;
              return (
                <button key={item.key} onClick={() => switchTab(item.key)} style={{
                  flex: 1, border: 'none', background: 'none', cursor: 'pointer',
                  padding: '9px 0 11px',
                  display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2,
                  color: isActive ? M : '#9ca3af',
                  position: 'relative',
                  transition: 'color 0.15s',
                }}>
                  {item.badge > 0 && (
                    <span style={{
                      position: 'absolute', top: 6, left: '50%', marginLeft: 4,
                      background: '#ef4444', color: '#fff',
                      fontSize: 8, fontWeight: 800, borderRadius: '50%',
                      width: 14, height: 14, lineHeight: '14px',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      border: '1.5px solid #fff', zIndex: 1,
                    }}>{item.badge > 9 ? '9+' : item.badge}</span>
                  )}
                  <span style={{
                    fontSize: 22, lineHeight: 1,
                    color: isActive ? M : '#9ca3af',
                    transform: isActive ? 'scale(1.15)' : 'scale(1)',
                    transition: 'transform 0.15s',
                  }}>{item.icon}</span>
                  <span style={{ fontSize: 9, fontWeight: isActive ? 800 : 500, letterSpacing: 0.2, lineHeight: 1 }}>
                    {item.label}
                  </span>
                  {isActive && (
                    <span style={{
                      position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)',
                      width: 24, height: 3, background: M, borderRadius: '3px 3px 0 0',
                    }} />
                  )}
                </button>
              );
            })}
          </div>
        </div>
      )}

    </LangCtx.Provider>
  );
}
